import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";

export function useProductionMachines(days: number = 14) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-machines", days],
    queryFn: () => service.getMachineActivity(days),
    staleTime: 5 * 60_000,       // 5 min
    refetchInterval: 10 * 60_000, // 10 min
  });
}
